import SbEditable from "storyblok-react";
import Image from "@/components/Image/image";
import Button from "@/components/Button/button";
import styles from "./coach-rail.module.scss";
import type { CoachRailStoryblok } from "./types";

interface Props {
  blok: CoachRailStoryblok;
}

const CoachRail = ({ blok }: Props) => {
  const coaches = Array.isArray(blok.coaches) ? blok.coaches : [];

  return (
    // @ts-expect-error
    <SbEditable content={blok}>
      <div className={styles.coachRail}>
        <div className={styles.coachRailGrid}>
          {coaches.length
            ? coaches.map((coach) => (
                <div key={coach._uid} className={styles.coachRailCard}>
                  <div className={styles.coachRailPhotoWrap}>
                    <div className={styles.coachRailPinkBg} />
                    {coach.image?.filename ? (
                      <Image
                        filename={coach.image.filename}
                        alt={coach.name || ""}
                        className={styles.coachRailImage}
                        sizes="(min-width: 1024px) 250px, 70vw"
                      />
                    ) : null}
                  </div>
                  <div className={styles.coachRailInfo}>
                    {coach.name ? (
                      <span className={styles.coachRailName}>{coach.name}</span>
                    ) : null}
                    {coach.speciality ? (
                      <span className={styles.coachRailSpeciality}>
                        {coach.speciality}
                      </span>
                    ) : null}
                  </div>
                </div>
              ))
            : null}
        </div>
        {blok.cta_link ? (
          <div className={styles.coachRailCta}>
            <Button link={blok.cta_link} btnStyle="border" size="medium">
              {blok.cta_text || "Explore the full roster"}
            </Button>
          </div>
        ) : null}
      </div>
    </SbEditable>
  );
};

export default CoachRail;
